import { atom } from 'jotai';
import { formErrorAtom } from '~/hooks/useFormData/atoms';

export const currentStepAtom = atom(1);

export const totalStepsAtom = atom(1);

export const hasNextAtom = atom((get) => {
  const current = get(currentStepAtom);
  const total = get(totalStepsAtom);

  return current < total;
});

export const hasPrevAtom = atom((get) => {
  const current = get(currentStepAtom);

  return current > 1;
});

export const handlePrevAtom = atom(null, (get, set) => {
  if (get(hasPrevAtom)) {
    set(currentStepAtom, (current) => current - 1);
    set(formErrorAtom, false);
  }
});

export const handleNextAtom = atom(null, (get, set) => {
  if (get(hasNextAtom)) {
    set(currentStepAtom, (current) => current + 1);
  }
});
